export const COUNTRY_CODE_OPTIONS = [
  { code: "+220", label: "Gambia (+220)", iso: "GM" },
  { code: "+221", label: "Senegal (+221)", iso: "SN" },
  { code: "+222", label: "Mauritania (+222)", iso: "MR" },
  { code: "+223", label: "Mali (+223)", iso: "ML" },
  { code: "+224", label: "Guinea (+224)", iso: "GN" },
  { code: "+225", label: "Ivory Coast (+225)", iso: "CI" },
  { code: "+233", label: "Ghana (+233)", iso: "GH" },
  { code: "+234", label: "Nigeria (+234)", iso: "NG" },
  { code: "+31", label: "Netherlands (+31)", iso: "NL" },
  { code: "+33", label: "France (+33)", iso: "FR" },
  { code: "+34", label: "Spain (+34)", iso: "ES" },
  { code: "+39", label: "Italy (+39)", iso: "IT" },
  { code: "+44", label: "United Kingdom (+44)", iso: "GB" },
  { code: "+46", label: "Sweden (+46)", iso: "SE" },
  { code: "+47", label: "Norway (+47)", iso: "NO" },
  { code: "+49", label: "Germany (+49)", iso: "DE" },
  { code: "+1", label: "United States/Canada (+1)", iso: "US" }
];

// Return a flag SVG URL for a given phone country code (falls back to empty string).
export const getFlagUrlForCode = (countryCode) => {
  const entry = COUNTRY_CODE_OPTIONS.find((item) => item.code === String(countryCode || "").trim());
  if (!entry || !entry.iso) return "";
  // Use flagcdn SVG for reliable cross-browser flags
  return `https://flagcdn.com/${entry.iso.toLowerCase()}.svg`;
};

export const splitPhoneWithCountryCode = (value, fallbackCode = "+220") => {
  const phoneValue = String(value || "").trim();
  if (!phoneValue) {
    return { countryCode: fallbackCode, number: "" };
  }

  const sortedCodes = COUNTRY_CODE_OPTIONS
    .map((item) => item.code)
    .sort((a, b) => b.length - a.length);

  const matchedCode = sortedCodes.find((code) => phoneValue.startsWith(code));

  if (!matchedCode) {
    return { countryCode: fallbackCode, number: phoneValue };
  }

  return {
    countryCode: matchedCode,
    number: phoneValue.slice(matchedCode.length).trim()
  };
};

export const buildPhoneWithCountryCode = (countryCode, number) => {
  const code = String(countryCode || "").trim();
  const localNumber = String(number || "").trim();

  if (!localNumber) return "";
  if (!code) return localNumber;

  return `${code}${localNumber}`;
};

export const getCountryCodeOption = (countryCode, fallbackCode = "+220") => {
  const normalizedCode = String(countryCode || fallbackCode).trim();
  return COUNTRY_CODE_OPTIONS.find((item) => item.code === normalizedCode)
    || COUNTRY_CODE_OPTIONS.find((item) => item.code === fallbackCode)
    || COUNTRY_CODE_OPTIONS[0];
};
